import type { Locale } from "@packages/i18n";

import type { BaseKeyFunction } from "../../../lib";
import type { SearchItemType } from "./types/enums";

export type KeySearchProps = {
  filters: {
    locale: Locale;
    type?: SearchItemType;
  };
  search: string;
};

export const keySearch: BaseKeyFunction<KeySearchProps> = ({
  filters,
  search,
}) => ["search", filters, search];
